<template>
  <div class="app-order-wrapper">
    <slot name="txtBefore"></slot>
    <!--    Warenkorb-->
    <div class="order-shopping-card overview-process" v-if="!showSuccess">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderShoppingCard">Warenkorb</slot>
      </div>
      <b-collapse v-model="showAllways">
        <OrderShoppingCard
        v-if="!showSummary"
        :mnpActive="mnpData.active"
        :presalesTariff="selectedPresalesTariff"
        :presalesTariffOption="selectedPresalesTariffOption"
        :tariffsExtra="tariffsExtra"
        :tariffOptionsExtra="tariffsOptionsExtra"
        :referFriend="referFriend"
        :gtmEventActive=true
        >
          <template v-for="slot in possibleChildSlotsFor('ShoppingCard')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </OrderShoppingCard>
      </b-collapse>
    </div>
    <!--    BestellOptionen-->
    <div class="order-options overview-process" v-if="!showSuccess">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderOptions">Bestelloptionen</slot>
        <b-btn v-if="showOptionsEditBtn" class="accordion-toggle" @click="editOptions">
          <slot name="btnEdit">Bearbeiten</slot>
        </b-btn>
      </div>
      <b-collapse v-model="showOptions">
        <OrderOptions :top-up-amounts="topUpAmounts" :mnp-providers="allMnpProviders.mnpProviders">
          <template v-for="slot in possibleChildSlotsFor('OrderOptions')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </OrderOptions>
      </b-collapse>
    </div>
    <!--    Persönliche Daten-->
    <div class="order-personal-data overview-process" v-if="!showSuccess">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderPersonalData">Persönliche Daten  {{showPersonalDataEditBtn}}</slot>
        <b-btn v-if="showPersonalDataEditBtn" class="accordion-toggle" @click="editPersonalData">
          <slot name="btnEdit">Bearbeiten</slot>
        </b-btn>
      </div>
      <b-collapse v-model="showPersonalData">
        <OrderPersonalData>
          <template v-for="slot in possibleChildSlotsFor('PersonalData')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </OrderPersonalData>
      </b-collapse>
    </div>
    <!--    Payment-->
    <div class="order-payment overview-process" v-if="!showSuccess">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderPayment">Zahlung</slot>
        <b-btn v-if="showPaymentEditBtn" class="accordion-toggle" @click="editPayment">
          <slot name="btnEdit">Bearbeiten</slot>
        </b-btn>
      </div>
      <b-collapse v-model="showPayment">
        <!-- v-model on collapse only hides the element - but it is still present inside the DOM -->
        <!-- Credit Card Oppwa inside Payment will try to handle the payon redirect after paypal also, but that's -->
        <!-- a bad idea. Paypal should only be handled in our summary/confirm step. To avoid the Payment Oppwa to be -->
        <!-- too greedy, we have to ensure it is not inside the DOM. an additional v-if on the component will do it -->
        <OrderPayment
          v-if="showPayment"
          :credit-card-frame-address="creditCardFrameAddress"
          :credit-card-redirect-url="creditCardRedirectUrl"
        >
          <template v-for="slot in possibleChildSlotsFor('OrderPayment')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </OrderPayment>
      </b-collapse>
    </div>
    <!--    Success-->
    <div class="order-success overview-process video-ident-method" v-if="showSuccess">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderSuccessVideoIdentWeb" v-if="getIdentMethod === 'videoIdentWeb'">Success</slot>
        <slot name="txtAccordionHeaderSuccessVideoIdentPost" v-if="getIdentMethod === 'videoIdentPost'">Success</slot>
        <slot name="txtAccordionHeaderSuccessPostIdent" v-if="getIdentMethod === 'postIdent'">Success</slot>
      </div>
      <b-collapse :visible="true">
        <OrderSuccess
          :slotData="getConfirmResponse"
          :show-print-preview-button="false"
        >
          <template v-for="slot in possibleChildSlotsFor('Success', (getIdentMethod.charAt(0).toUpperCase() + getIdentMethod.slice(1)))" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </OrderSuccess>
      </b-collapse>
    </div>
    <!--    Summary-->
    <div class="order-summary overview-process">
      <div class="accordion-header overview-process">
        <slot name="txtAccordionHeaderSummary" v-if="!showSuccess">Zusammenfassung</slot>
        <slot name="txtAccordionHeaderSummaryWhenSuccess" v-else>Zusammenfassung</slot>
      </div>
      <b-collapse v-model="showSummary">
        <OrderSummary
          :presalesTariff="selectedPresalesTariff"
          :presalesTariffOption="selectedPresalesTariffOption"
          :tariffsExtra="tariffsExtra"
          :tariffOptionsExtra="tariffsOptionsExtra"
          :mnpData="mnpData"
          :paypal-redirect-url="paypalRedirectUrl"
          :referFriend="referFriend"
        >
          <template v-for="slot in possibleChildSlotsFor('Summary')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </OrderSummary>
      </b-collapse>
    </div>
    <slot name="txtAfter"></slot>
  </div>
</template>
<script>

import OrderShoppingCard, { stepName as shoppingCardStepName } from '../ShoppingCard.vue'
import OrderOptions, { stepName as optionsStepName } from '../Options/EnterOptions.vue'
import OrderPayment, { stepName as paymentStepName } from '../Payment/EnterPaymentData.vue'
import OrderSummary, { stepName as summaryStepName } from '../Summary/OrderSummary.vue'
import OrderSuccess, { stepName as successStepName } from '../Success/ShowSuccess.vue'
import OrderPersonalData, { stepName as personalDataStepName } from '../PersonalData/EnterPersonalData.vue'
import { mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'
import extraData from '@/mixins/extraData'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import slotProxy from '@/mixins/slotProxy'

const processSteps = [shoppingCardStepName, optionsStepName, personalDataStepName, paymentStepName, summaryStepName, successStepName]
export default {
  name: 'OrderWrapper',
  data () {
    return {
      showAllways: true,
      presalesTariff: null,
      topUpAmounts: {
        directAmounts: {
          amount: [],
          default: 0
        },
        autoAmounts: {
          monthly: {
            amount: [],
            default: 0
          },
          threshold: {
            amount: [],
            default: 0,
            trigger: [],
            defaultTrigger: 0
          }
        }
      },
      allMnpProviders: {
        mnpProviders: []
      }
    }
  },
  components: {
    OrderSuccess,
    OrderPayment,
    OrderSummary,
    OrderOptions,
    OrderShoppingCard,
    OrderPersonalData
  },
  computed: {
    showShoppingCard: {
      get () {
        return this.currentStep === shoppingCardStepName
      },
      set () {
      }
    },
    showOptions: {
      get () {
        return this.currentStep === optionsStepName
      },
      set () {
      }
    },
    showPersonalData: {
      get () {
        return this.currentStep === personalDataStepName
      },
      set () {
      }
    },
    showPayment: {
      get () {
        return this.currentStep === paymentStepName
      },
      set () {
      }
    },
    showSummary: {
      get () {
        return this.currentStep === summaryStepName || this.showSuccess
      },
      set () {
      }
    },
    showSuccess: {
      get () {
        return this.currentStep === successStepName
      },
      set () {
      }
    },
    showOptionsEditBtn: {
      get () {
        return processSteps.indexOf(this.currentStep) > processSteps.indexOf(optionsStepName)
      },
      set () {
      }
    },
    showPersonalDataEditBtn: {
      get () {
        return processSteps.indexOf(this.currentStep) > processSteps.indexOf(personalDataStepName)
      },
      set () {
      }
    },
    showPaymentEditBtn: {
      get () {
        return processSteps.indexOf(this.currentStep) > processSteps.indexOf(paymentStepName)
      },
      set () {
      }
    },
    ...mapGetters('orderProduct', [
      'getStep',
      'getProcessId',
      'getConfirmResponse',
      'getCustomer',
      'getOptions',
      'getIdentMethod'
    ]),
    ...mapGetters([
      'brand'
    ]),
    ...mapGetters('orderProduct/product', [
      'getTariffId',
      'getTariffOptionId',
      'getDefaultTariffId'
    ]),
    ...mapGetters('orderProduct/mnp', [
      'mnpData'
    ]),
    presalesTariffs () {
      return this.presalesTariff?.bookablePresalesTariffs
    },
    selectedPresalesTariff () {
      return this.presalesTariff?.bookablePresalesTariffs.find(item => item.tariffId === this.getTariffId)
    },
    selectedPresalesTariffOption () {
      return this.selectedPresalesTariff?.tariffOptions.bookablePresalesTariffOptions.find(item => item.tariffoptionId === this.getTariffOptionId)
    },
    currentStep: function () {
      return this.getStep
    },
    tariffsExtra () {
      return this.extraData?.find(item => item.tariffId === this.getTariffId)
    },
    referFriend () {
      return this.$store.getters['orderProduct/referFriend/showReferFriend']
    },
    tariffsOptionsExtra () {
      return this.extraData?.find(item => item.tariffOptionId === this.getTariffOptionId)
    },
    slotData: function () {
      return {
        tariffInfo: this.selectedPresalesTariff,
        step: this.currentStep
      }
    }
  },
  mounted () {
    const urlParameters = new URLSearchParams(window.location.search)
    if (urlParameters.get('prod')) {
      this.commitTariffId(urlParameters.get('prod'))
      this.updateStep('shoppingCard')
    }
    if (urlParameters.get('tos')) {
      this.commitTariffOptionId(urlParameters.get('tos'))
      this.updateStep('shoppingCard')
    }
    if (!urlParameters.get('tos')) {
      this.commitTariffOptionId(null)
    }

    if (this.inIframe()) {
      document.getElementById('footer-cancellation').style.display = 'none'
    }
  },
  methods: {
    ...mapMutations('orderProduct', [
      'changeStep'
    ]),
    ...mapMutations('orderProduct/product', [
      'commitTariffId',
      'commitTariffOptionId'
    ]),
    editPersonalData () {
      this.updateStep(personalDataStepName)
    },
    editPayment () {
      this.updateStep(paymentStepName)
    },
    editOptions () {
      this.updateStep(optionsStepName)
    },
    updateStep (step) {
      this.changeStep({ step: step })
    },
    inIframe () {
      try {
        return window.self !== window.top
      } catch (e) {
        return true
      }
    }
  },
  mixins: [
    transaction('order'),
    extraData(),
    slotProxy()
  ],
  props: {
    creditCardFrameAddress: {
      type: String,
      required: true
    },
    creditCardRedirectUrl: {
      type: String
    },
    paypalRedirectUrl: {
      type: String
    }
  },
  apollo: {
    presalesTariff: function () {
      return wrapQuery(
        gql`query order ($brand: String!) {
            presalesTariff(brand: $brand) {
                bookablePresalesTariffs {
                  tariffId
                  name
                  baseTariffId
                  basicFee
                  formattedBasicFee
                  connectionFee
                  contractPeriod
                  marketingGroup
                  phoneFlat
                  smsFlat
                  runtime {
                    amount
                    formattedUnit
                    unit
                  }
                  tariffOptions {
                    bookablePresalesTariffOptions {
                        name
                        tariffoptionId
                        formattedPrice
                        phoneFlat
                        smsFlat
                        price
                        duration {
                            amount
                            formattedUnit
                            unit
                        }
                        volumes {
                            amount
                            formattedUnit
                            type
                            unit
                        }
                    }
                  }
                  starterKit {
                      creditBalance
                      productNumber
                      shippingCost
                      singlePaymentFee
                      formattedCombinedCost
                      formattedShippingCost
                      formattedSinglePaymentFee
                      withDevice
                      withMnp
                    }
                    volumes {
                      amount
                      formattedUnit
                      type
                      unit
                    }
                }
            }
            topUpAmounts(brand: $brand) {
              directAmounts {
                amount
                default
              }
              autoAmounts {
                monthly {
                  amount
                  default
                }
                threshold {
                  amount
                  default
                  trigger
                  defaultTrigger
                }
              }
            }
            allMnpProviders {
              mnpProviders {
                key
                name
                networks {
                  key
                  name
                }
              }
            }
}`, this, ['presalesTariff', 'topUpAmounts', 'allMnpProviders'], { brand: this.brand }, function (data) {
        }
      )
    }
  }
}
</script>
